import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './page-nav.module.css';
import classNames from 'classnames';
import { Link } from 'react-scroll';

/**
 * Multi-level vertical menu allowing to scroll to a certain section of the page
   by clicking on a certain menu item
 */

export default class InPageNavigation extends Component {
  static propTypes = {
    items:
      PropTypes.shape({
        world: PropTypes.arrayOf(PropTypes.shape({
          label: PropTypes.string.isRequired,
          noSubItemsIndent: PropTypes.bool,
          scrollTo: PropTypes.string,
          items: PropTypes.array,
          length: PropTypes.function
        })),
        regional: PropTypes.arrayOf(PropTypes.shape({
          label: PropTypes.string.isRequired,
          noSubItemsIndent: PropTypes.bool,
          scrollTo: PropTypes.string,
          items: PropTypes.array,
          length: PropTypes.function
        })),
        countries: PropTypes.arrayOf(PropTypes.shape({
          label: PropTypes.string.isRequired,
          noSubItemsIndent: PropTypes.bool,
          scrollTo: PropTypes.string,
          items: PropTypes.array
        }))
      })

  };
  renderLabel = item => {
    const className = classNames(styles.label, item.items && styles.hasSubItems, item.scrollTo && styles.link);

    if (item.scrollTo) {
      return (
        <Link to={item.scrollTo} className={className} spy={true} smooth={true} duration={300}>
          {item.label}
        </Link>
      );
    }
    return <span className={className || ''}>{item.label}</span>;
  };


  renderItems = (navItems, level = 1) => {
    if (!navItems || !Array.isArray(navItems)) {
      return null;
    }
    return navItems.map(item => {
      const { label, items } = item;
      if (!items) {
        return (
          <li className={classNames(styles.li, level === 1 && styles.level1)} data-level={level} key={label}>
            {this.renderLabel(item)}
          </li>
        );
      }

      return (
        <li className={classNames(styles.li, level === 1 && styles.level1)} key={label} data-level={level}>
          {this.renderLabel(item)}
          <ul className={classNames(styles.ul, item.noSubItemsIndent && styles.noSubItemsIndent)}>
            {this.renderItems(items, level + 1)}
          </ul>
        </li>
      );
    });
  };
  render() {
    const { items } = this.props;
    let worldItems = <div> </div>;
    let worldLabel;

    let regionalLabel;
    let regionalItems = <div> </div>;

    let countryLabel;
    let countryItems =  <div> </div>;
    if (items.world && items.world.length > 0) {
      worldLabel = <h2>World</h2>;
      worldItems = this.renderItems(this.props.items.world, null, 'world') ;
    }
    if (items.regional && items.regional.length > 0) {
      regionalLabel = <h2>Regional</h2>;
      regionalItems = this.renderItems(this.props.items.regional, null, 'regional');
    }
    if (items.countries && items.countries.length > 0) {
      countryLabel = <h2>Countries</h2>;
      countryItems = this.renderItems(this.props.items.countries, null, 'country');
    }
    return (
      <ul className={styles.inPageNav}>
        {worldLabel}
        {worldItems}

        {regionalLabel}
        {regionalItems}

        {countryLabel}
        {countryItems}
      </ul>
    );
  }
}
